if($('.id--12').length){
    if($('.id--12 .content-inner th').length){
        $('.content-inner h1').after('<p>'+klientCenterMessage+'</p>')
        $('.id--12 .content-inner th').each(function(){
            if($(this).text().trim() === 'Datum'){
                $(this).text('Datum objednávky');
            }
        })

        
    }
}

if($('.id--18').length){
    if($('.id--18 .content-inner th').length){
        $('.content-inner h1').after('<p>'+klientCenterMessage+'</p>')
        $('.id--18 .content-inner th').each(function(){
            if($(this).text().trim() === 'Datum'){
                $(this).text('Datum objednávky');
            }
        })

        
    }
}